import { Avatar, AvatarGroup, Box, Text, Tooltip, VStack } from '@chakra-ui/react';
import { useListCollaborationUsers } from '../../hooks/useListCollaborationUsers';

interface OrderCollaborationAvatarsProps {
    orderId: string;
}

const OrderCollaborationAvatars = ({ orderId }: OrderCollaborationAvatarsProps) => {
    const { data: users = [], isLoading } = useListCollaborationUsers(orderId);

    if (isLoading || users.length === 0) {
        return null;
    }

    return (
        <Tooltip
            label={
                <VStack align="start" spacing={0.5}>
                    {users.map((user) => (
                        <Text key={user._id} fontSize="sm">
                            {user.displayName}
                        </Text>
                    ))}
                </VStack>
            }
            placement="bottom"
            hasArrow
            openDelay={200}
        >
            <Box display="inline-flex">
                <AvatarGroup size="sm" max={2} spacing="-0.6rem">
                    {users.map((user) => (
                        <Avatar
                            key={user._id}
                            name={user.displayName}
                            bg="#0071E3"
                            color="white"
                            fontSize="xs"
                            fontWeight="semibold"
                        />
                    ))}
                </AvatarGroup>
            </Box>
        </Tooltip>
    );
};

export default OrderCollaborationAvatars;
